<template>
  <div>
    <BaseSingleOrderReceipt
      :receiptId="activeReceiptId"
      @close="closeReceipt"
      v-if="activeReceiptId"
    ></BaseSingleOrderReceipt>
    <div v-if="receipts.length > 0" class="flex flex-row px-2 gap-2">
      <div
        v-for="receipt in receipts"
        :key="receipt.id"
        @click="openReceipt(receipt.id)"
        class="flex flex-col justify-center items-center p-2 border border-gray-200 rounded-lg cursor-pointer"
      >
        <img
          class="w-12 flex-shrink-0"
          :src="require(`@/assets/icons/docs-icon.svg`)"
          alt="receipt"
        />
        {{ receipt.createdAt | dateWithHours }}
        <button>
          view
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BaseOrderReceipts",
  props: {
    orderUUID: {
      type: String,
      required: true
    },
    receipts: {
      type: Array,
      required: true
    },
    activeReceiptId: {
      type: String,
      required: false
    }
  },
  methods: {
    openReceipt(receiptId) {
      this.$emit("update:activeReceiptId", receiptId);
    },
    closeReceipt() {
      this.$emit("update:activeReceiptId", null);
    }
  }
};
</script>
